export default "https://cdn-static.gokick.com/assets/e21cd8011b9b3a74c4cd288f1b94a870d12ac47c/images/spearmint-flavor.4c44d265d2ca14e44f653db82c437465.png";